module.exports = __webpack_public_path__ + "static/media/study 201102.55ddfff8.png";